<template>
    <ion-label slot="end" v-if="src && src.length > 0">
        <ion-img :src="src" @ionError="brokeImage"></ion-img>
    </ion-label> 
</template>

<script>
export default {
  name: "label-image",
  components: {},
  props: ["image"],
  data() {
    return {
      src: null
    }
  },
  computed: {
    broken() {
      return require('../assets/broken.png');
    }
  },
  created() {
    this.src = this.image;
  },
  methods: {
    brokeImage() {
      this.src = this.broken;
    }
  }
}
</script>

<style scoped>
ion-img {
  width: 300px;
  max-width: 100%;
  margin-left: 0;
  margin-right: auto;
  margin-bottom: 15px;
}
</style>